// import React from 'react';

// export default function Pagination() {
//   return (
//     <ul className="cs_pagination_box">
//       <li>
//         <button className="cs_pagination_arrow cs_center">
//           <img src="images/icons/left_arrow_blue.svg" alt="Icon" />
//         </button>
//       </li>
//       <li>
//         <button className="cs_pagination_item cs_center active">1</button>
//       </li>
//       <li>
//         <button className="cs_pagination_item cs_center">2</button>
//       </li>
//       <li>
//         <button className="cs_pagination_item cs_center">3</button>
//       </li>
//       <li>
//         <span className="cs_pagination_item cs_center">...</span>
//       </li>
//       <li>
//         <button className="cs_pagination_item cs_center">8</button>
//       </li>
//       <li>
//         <button className="cs_pagination_arrow cs_center">
//           <img src="images/icons/right_arrow_blue.svg" alt="Icon" />
//         </button>
//       </li>
//     </ul>
//   );
// }

import React from 'react';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage > 2) pages.push(1);
      if (currentPage > 3) pages.push('...');
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if (currentPage < totalPages - 2) pages.push('...');
      if (currentPage < totalPages) pages.push(totalPages);
    }

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <ul className="cs_pagination_box">
      <li>
        <button
          className="cs_pagination_arrow cs_center"
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        >
          <img src="images/icons/left_arrow_blue.svg" alt="Previous" />
        </button>
      </li>

      {pages.map((page, index) =>
        page === '...' ? (
          <li key={index}>
            <span className="cs_pagination_item cs_center">...</span>
          </li>
        ) : (
          <li key={index}>
            <button
              className={`cs_pagination_item cs_center ${page === currentPage ? 'active' : ''}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        )
      )}

      <li>
        <button
          className="cs_pagination_arrow cs_center"
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          <img src="images/icons/right_arrow_blue.svg" alt="Next" />
        </button>
      </li>
    </ul>
  );
}
